import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CLEAR_ERROR } from '../../store/types';
import ErrorMessage from './ErrorMessage';
import { useLocation, useNavigate } from 'react-router-dom';
// import LoginModal from './LoginModal';

const ErrorNotifier = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation()

    const error = useSelector(state => state?.errors?.error);
    const dismissHandler = () => {
        dispatch( {
            type: CLEAR_ERROR
        })
    }

    useEffect(() => {
        if ((error?.response?.data?.errorCode !== 'expired-token' && error?.response?.data?.errorCode !== 'unauthorized' )|| location.pathname === '/') return;

        const returnUrl = `${location.pathname}${location.search}`

        navigate({
            pathname: '/',
            search: `?${new URLSearchParams({
                returnUrl,
                expiredToken: true
            }).toString()}`
        }, { replace: true })
    }, [error, location.pathname, location.search, navigate])

    if (!error) return null;


    if (!error || (error && !error?.response)) {
        return (
            <ErrorMessage message={`Network Error`} dismissHandler={()=>{dismissHandler()}} />
        )
    }

    if (error?.response?.data && (error?.response?.data?.errorCode === 'expired-token' || error?.response?.data?.errorCode === 'unauthorized')) {
        return (
            <ErrorMessage message={`Your log in session has expired or is invalid, please log in again to continue.`} dismissHandler={()=>{dismissHandler()}} />
        )
    }

    if (error?.response?.data && error?.response?.data?.errorCode !== 'expired-token') {
    // if (error) {
        console.log('error notifier: ', error)
        setTimeout(() => {
            dismissHandler()
        }, 5000);
        
        return (
            <ErrorMessage message={error?.response?.data?.message} dismissHandler={()=>{dismissHandler()}} />
        )
    }
}

export default ErrorNotifier
